// eslint-disable-next-line max-len
// TODO: Need to refactor: this code the same as wgnp/static_source/components/password_operations/step_confirm_sms.js

import SmsVerificationCellphoneRecoveryForm from '../sms_verification_cellphone_recovery_form';

import CancelOperationUrlPropMixin from '../../mixins/cancelOperationUrlProp';
import CellphoneRecoveryOperationPropMixin from '../../mixins/cellphoneRecoveryOperationProp';

export default {
    name: 'cellphone-recovery-operations-step-confirm-sms',
    template: '#js-tmpl-cellphone-recovery-operations-step-confirm-sms',

    mixins: [CellphoneRecoveryOperationPropMixin, CancelOperationUrlPropMixin],

    components: {
        SmsVerificationCellphoneRecoveryForm,
    },

    computed: {
        userCellphone() {
            return this.$store.state.cellphone_recovery.cellphone;
        },
        operationUrls() {
            return this.$store.state[this.operation].urls;
        },
        submitUrl() {
            return this.operationUrls.cellphoneRecoveryVerifySmsUrl;
        },
        linkToPersonalPage() {
            return this.$store.state.cellphone_recovery.urls.personalUrl;
        }
    },

    methods: {
        onSubmitSuccess() {
            this.$emit('update', {
                operationVerified: true,
            });
            window.location.href = this.linkToPersonalPage;
        },
    },
};
